import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { MOCK_DEMONSTRATIVOS } from '../dados-simulados';

export interface FiltroDemonstrativos {
  busca?: string;
  mes?: string;
  tipoPessoa?: 'PF' | 'PJ' | 'TODOS';
}

/** FIN-XXX: demonstrativos financeiros por competência — standalone e embutida
 * na aba "Demonstrativos" do Fechamento Mensal V2. */
export function useDemonstrativos(filtro: FiltroDemonstrativos) {
  return useQuery({
    queryKey: ['financeiro', 'demonstrativos', filtro],
    queryFn: async () => {
      let filtrados = [...MOCK_DEMONSTRATIVOS];
      if (filtro.mes) filtrados = filtrados.filter((d) => d.mesReferencia.startsWith(filtro.mes!));
      if (filtro.tipoPessoa && filtro.tipoPessoa !== 'TODOS') {
        filtrados = filtrados.filter((d) => d.tipoPessoa === filtro.tipoPessoa);
      }
      if (filtro.busca) {
        const termo = filtro.busca.toLowerCase();
        filtrados = filtrados.filter((d) => d.credenciadoNome.toLowerCase().includes(termo));
      }
      return filtrados;
    },
  });
}

/*
 * Enviar demonstrativos NÃO tem gancho aqui, de propósito: ainda não há
 * endpoint, e um gancho que espera 500 ms e devolve `{ ok: true }` fazia a tela
 * fingir que enviou. A ação mostra o aviso de indisponibilidade
 * (`DemonstrativosPage.tsx`). Volta junto com o endpoint.
 */

export function useReabrirCalculoDemonstrativo() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (_variaveis: { credenciadoId: string; motivo: string }) => {
      await new Promise((resolve) => setTimeout(resolve, 500));
      return { ok: true as const };
    },
    onSettled: () =>
      void queryClient.invalidateQueries({ queryKey: ['financeiro', 'demonstrativos'] }),
  });
}
